export default {
	bind(el, binding) {
		const cb = binding.value;

		el.listener = function (e) {
			if (el !== e.target && !el.contains(e.target)) {
				cb();
			}
		};

		document.body.addEventListener("click", el.listener);
	},

	unbind(el) {
		document.body.removeEventListener("click", el.listener);
	}
};
